import { render, staticRenderFns } from "./ShowDialogSliderPrincipal.vue?vue&type=template&id=26dd0d5c&scoped=true"
import script from "./ShowDialogSliderPrincipal.vue?vue&type=script&lang=js"
export * from "./ShowDialogSliderPrincipal.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogSliderPrincipal.vue?vue&type=style&index=0&id=26dd0d5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd0d5c",
  null
  
)

export default component.exports